export default __webpack_public_path__ + "static/media/Site mercado.59120c04.svg";